<template>
    <div class="al-c flex-box">
        <span style="line-height: 28px;">选择时间：</span>

        <el-button :type="btnType == 'today' ? 'primary' : ''" size="mini" @click="setDate('today')">今日</el-button>
        <el-button :type="btnType == '7day' ? 'primary' : ''" size="mini" @click="setDate('7day')">最近7日</el-button>
        <el-button :type="btnType == '30day' ? 'primary' : ''" size="mini" @click="setDate('30day')">最近30日</el-button>
        <el-button :type="btnType == 'toyear' ? 'primary' : ''" size="mini" @click="setDate('toyear')">今年</el-button>
        <el-button :type="btnType == 'lastyear' ? 'primary' : ''" size="mini" @click="setDate('lastyear')">去年</el-button>
        <!--<el-button :type="btnType == 'lastlastyear' ? 'success' : ''" size="mini" @click="setDate('lastlastyear')">前年</el-button>-->
        <el-date-picker class="ml10" v-model="startDate" type="date" placeholder="选择开始时间" format="yyyy-MM-dd" value-format="timestamp" :picker-options="pickOptionForStart" @change="changeValue"></el-date-picker>
        <span class="ml10 mr10">至</span>
        <el-date-picker v-model="endDate" type="date" placeholder="选择结束时间" format="yyyy-MM-dd" value-format="timestamp" default-time="23:59:59" :picker-options="pickOptionForEnd" @change="changeValue"></el-date-picker>
    </div>
</template>

<script>
    export default {
        name: "DateComponent",
        components: {},
        props: ["loading"],
        data() {
            return {
                btnType: "today",
                startDate: Date.now(),
                endDate: Date.now(),
                minDate: null,
                pickOptionForStart: {
                    disabledDate: time => {
                        if (this.endDate) {
                            return (
                                (time.getTime() > this.endDate ? true : false) ||
                                time.getTime() > Date.now()
                            );
                        } else {
                            return time.getTime() > Date.now();
                        }
                    }
                },
                pickOptionForEnd: {
                    disabledDate: time => {
                        if (this.startDate) {
                            return (
                                (time.getTime() < this.startDate ? true : false) ||
                                time.getTime() > Date.now()
                            );
                        } else {
                            return time.getTime() > Date.now();
                        }
                    }
                }
            };
        },
        created() {},
        computed: {},
        mounted() {},
        methods: {
            setDate(btnType) {
                this.btnType = btnType;
                let obj={
                    "today":'0',
                    "7day":'1',
                    "30day":'2',
                    "toyear":'3',
                    "lastyear":'4'
                }
                switch (btnType) {
                    case "today":
                        this.startDate = Date.now();
                        this.endDate = Date.now();
                        break;
                    case "7day":
                        this.startDate = Date.now() - 3600000 * 24 * 7;
                        this.endDate = Date.now();
                        break;
                    case "30day":
                        this.startDate = Date.now() - 3600000 * 24 * 30;
                        this.endDate = Date.now();
                        break;
                    case "toyear":
                        let myDate0 = new Date();
                        let year0 =  myDate0.getFullYear();
                        let startdate0 = new Date(year0+'-01-01');
                        let enddate0 = new Date(year0+'-12-31');
                        this.startDate =startdate0.getTime();
                        this.endDate = enddate0.getTime();
                        break;
                    case "lastyear":
                        let myDate = new Date();
                        let year =  Number(myDate.getFullYear())-1;
                        let startdate = new Date(year+'-01-01');
                        let enddate = new Date(year+'-12-31');
                        this.startDate =startdate.getTime();
                        this.endDate = enddate.getTime();
                        break;
                    case "lastlastyear":
                        let myDate1 = new Date();
                        let year1=  Number(myDate1.getFullYear())-2;
                        let startdate1 = new Date(year1+'-01-01');
                        let enddate1 = new Date(year1+'-12-31');
                        this.startDate =startdate1.getTime();
                        this.endDate = enddate1.getTime();
                        break;
                    default:
                        break;
                }
                this.$nextTick(() => {
                    this.$emit("change", [this.startDate, this.endDate]);
                    this.$emit("changehandle", [this.timestampToTime(this.startDate),
                        this.timestampToTime(this.endDate)],obj[this.btnType]);
                });
            },
            changeValue(value) {
                this.btnType = "other";
                // if (value && value.length) {
                //   this.$emit("change", [
                //     this.$options.filters.filterDate(this.startDate, "yyyy-MM-dd"),
                //     this.$options.filters.filterDate(this.endDate, "yyyy-MM-dd")
                //   ]);
                // }
            },
            getValue() {
                let startDate = this.startDate || Date.now() - 86400000 * 30;
                let endDate = this.endDate || Date.now();
                endDate = this.btnType == "other" ? endDate + 86399000 : endDate;
                return [startDate, endDate];
            },
            getValueStr() {
                let startDate = this.startDate || Date.now() - 86400000 * 30;
                let endDate = this.endDate || Date.now();
                endDate = this.btnType == "other" ? endDate + 86399000 : endDate;

                return [this.timestampToTime(startDate), this.timestampToTime(this.timestampToTime(endDate))];
            },
            timestampToTime(timestamp) {
                let date = new Date(timestamp);
                let Y = date.getFullYear() + '-';
                let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                let D = date.getDate() < 10 ?  '0'+date.getDate(): date.getDate();
                return Y+M+D
            }

        }
    };
</script>

<style scoped lang="less">
    .title::before,
    .title::after {
        content: "";
        display: block;
        position: absolute;
        top: 50%;
        margin-top: -1px;
        width: 100px;
        height: 1px;
        background: #475eb7;
    }

    .title::before {
        right: 130%;
    }

    .title::after {
        left: 130%;
    }
    /deep/.el-input--small .el-input__inner{
        cursor: pointer;
    }
</style>
